import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FormsModule } from "@angular/forms";
import { TranslateModule } from "@ngx-translate/core";
import { PerfectScrollbarModule } from "@bfx/ngx-perfect-scrollbar";
import { PERFECT_SCROLLBAR_CONFIG } from "@bfx/ngx-perfect-scrollbar";
import { PerfectScrollbarConfigInterface } from "@bfx/ngx-perfect-scrollbar";
import { AgGridModule } from "@bfx/ag-grid-angular";

import { BfxElementsLibraryModule } from "../bfx-element-library/bfx-elements-library.module";
import { BfxScratchPadService } from "./services/bfx-scratchpad.service";
import { OrderEntryModule } from "../order-entry/order-entry.module";
import { BfxSharedModule } from "../bfx-shared/bfx-shared.module";
import { TabViewModule } from "@bfx/primeng/tabview";
import { MenuModule } from "@bfx/primeng/menu";
import { CheckboxModule } from "@bfx/primeng/checkbox";
import { ButtonModule } from "@bfx/primeng/button";
import { BfxScratchPadComponent } from "./bfx-scratchpad.component";
import { BaseComponentsModule } from "shared/base-components/base-components.module";
import { MultiAllocProductRenderer } from "app/bfx-blotter-common/renderers/MultiAllocProductRenderer";
import { BfxBlotterCommonModule } from "app/bfx-blotter-common/bfx-blotter-common.module";

export const DEFAULT_PERFECT_SCROLLBAR_CONFIG: PerfectScrollbarConfigInterface = {
  suppressScrollX: true,
};

@NgModule({
  imports: [
    BfxBlotterCommonModule,
    BfxSharedModule,
    CommonModule,
    TranslateModule,
    BfxElementsLibraryModule,
    TabViewModule,
    AgGridModule.withComponents([MultiAllocProductRenderer]),
    MenuModule,
    CheckboxModule,
    FormsModule,
    ButtonModule,
    OrderEntryModule,
    PerfectScrollbarModule,
    BaseComponentsModule,
  ],
  declarations: [BfxScratchPadComponent],
  providers: [
    {
      provide: PERFECT_SCROLLBAR_CONFIG,
      useValue: DEFAULT_PERFECT_SCROLLBAR_CONFIG,
    },
    BfxScratchPadService,
  ],
  exports: [BfxScratchPadComponent],
  bootstrap: [BfxScratchPadComponent],
})
export class BfxScratchPadModule {}
